export const getShelfLocationsExcluding = (excluded: string[], shelfLocations: string[]): string => {
  const remaining = shelfLocations.filter(p => !excluded.includes(p))
  return remaining.join(', ')
}
